import PropTypes from 'prop-types';
import { Heading } from '@cof/plastic-components';
import { useTheme } from 'styled-components';

import useIsPtd from '../../utilities/useIsPtd';

const ObLandingHeading = ({ paddingTop, textAlign, Text, titlePath }: any) => {
    const theme = useTheme();
    const isPtd = useIsPtd();

    return (
        <Heading
            // @ts-expect-error TS2339: Property 'pages' does not exist on type 'DefaultTheme'.
            color={theme?.pages?.['openBanking']?.headingColor}
            // @ts-expect-error TS2322: Type '"600"' is not assignable to type 'ResponsiveValue<keyof FontWeightKeys, DefaultTheme> | undefi
            fontWeight="600"
            data-qa-id="OB-landing-heading"
            fontSize={['headingLargeMobile', null, 'headingMediumDesktop']}
            paddingBottom={['0.8rem', null, '0.8rem']}
            paddingTop={paddingTop}
            textAlign={textAlign}
            data-qm-allow
        >
            <Text path={isPtd ? 'PtdTitle' : titlePath} params={{ 'data-qm-allow': 'true' }} />
        </Heading>
    );
};

ObLandingHeading.propTypes = {
    paddingTop: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    textAlign: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    Text: PropTypes.func.isRequired,
    titlePath: PropTypes.string.isRequired
};

export default ObLandingHeading;
